<template>
  <div>
    <h2>Funcionalidade: {{ funcionalidade.nome }}</h2>
    <h3>ID: {{ funcionalidade.idFuncionalidade }}</h3>
    <p>Funcionalidade ainda não implementada</p>
    <br>

    <figure class="my-code">
      <figcaption>Payload</figcaption>
      <pre><code>{{ payload }}</code></pre>
    </figure>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FuncDefault',
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    payload () {
      return JSON.stringify(this.funcionalidade, null, 4)
    }
  }
}
</script>

<style scoped>
.my-code > pre code {
  background-color: #eee;
  border: 1px solid #999;
  display: block;
  padding: 10px;
  white-space: break-spaces;
}
</style>
